import { Grid } from "@material-ui/core";
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  height: 100%;
`;

export const FilterInputs = styled(Grid)`
  display: flex;
  flex: 1;
  flex-direction: row;
  margin: 0px;

  div {
    & + div {
      border-left: 1px solid #CACACA;
    }
  }
`;

export const FilterButtonsContainer = styled.div`
  display: flex;
  gap: 16px;
  justify-content: flex-end;
  margin-left: 16px;

  button {
    max-height: 40px;
  }
`;

export const ListContainer = styled.div`
  padding-left: 26px;
  padding-right: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
  z-index: 0;
`;

export const LoadingSkeletonContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const SearchIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
`;

export const FetchMetaDataContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 26px;
  justify-content: space-between;
`;

export const ListCounterContainer = styled.div``;

export const CounterLabel = styled.span`
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  color: #000;
  font-weight: 600;
`;

export const ListOrderContainer = styled.div``;

export const ListOrderLabel = styled.span``;
